import React, { useState } from 'react';
import { Card, List, Button, Modal, message, Typography } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import UploadWorkspace from '../../components/business/batchImport/UploadWorkspace';
import BatchList from '../../components/business/batchImport/BatchList';
import { UploadDialog, PrecheckDialog, ImportDialog, ReportDialog } from '../../components/business/batchImport/BatchDialogs';
import api from '../../services/api';

const templates = [
  {
    name: '债权批量发布模板-全量新增_v1.0.xlsx',
    description: '系统内不存在当前债权，全量新增',
    type: 'full',
  },
  {
    name: '债权批量发布模板-增量仅新增_v1.0.xlsx',
    description: '系统内存在当前债权，增加新的债务人和证据材料',
    type: 'append_new',
  },
  {
    name: '债权批量发布模板-增量全更新_v1.0.xlsx',
    description: '系统内存在当前债权，删除当前债权下的所有债务人和证据材料，使用文件内的数据全量更新',
    type: 'append_update',
  },
];

// 下载模板 - 通过 API 获取签名 URL 后下载
const downloadTemplate = async (templateType) => {
  try {
    // 调用后端接口获取签名下载链接
    const res = await api.get(`/api/pubs/v1/debt/batch/template/download-url`, {
      params: { templateType },
      dedup: false,  // 禁用去重，允许多次下载
    });
    if (res?.data?.downloadUrl) {
      // 在新窗口打开 OSS 签名 URL（带认证信息）
      window.open(res.data.downloadUrl, '_blank');
    } else {
      message.error('获取下载链接失败');
    }
  } catch (error) {
    message.error(error.message || '下载失败，请稍后重试');
  }
};

const BatchPublishPage = () => {
  const [explainOpen, setExplainOpen] = useState(false);
  const [uploadOpen, setUploadOpen] = useState(false);
  const [precheckOpen, setPrecheckOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [importOpen, setImportOpen] = useState(false);
  const [reportRecord, setReportRecord] = useState(null);
  const [workspace, setWorkspace] = useState(null);
  const [refreshToken, setRefreshToken] = useState(0);
  const confirmUploadWorkspace = (ws) => {
    setWorkspace(ws);
    setUploadOpen(false);
    message.success('上传成功，已创建工作区');
  };
  return (
    <div className="page-container p-debt-management-batch-publish">
      <div className="page-content page-content-wide space-y-md">
        <div className="page-title">批量发布</div>

        <Card
          title="上传工作区"
          className="card-compact"
        >
          <div style={{ marginBottom: 8 }}>
            <Typography.Link style={{ fontSize: 12, color: 'var(--text-color-tertiary)' }} onClick={() => setExplainOpen(true)}>
              模板说明及下载
            </Typography.Link>
          </div>
          <UploadWorkspace
            workspace={workspace}
            onPrecheck={() => setPrecheckOpen(true)}
            onImport={() => setImportOpen(true)}
            onReupload={() => {
              setWorkspace(null);
              setPrecheckOpen(false);
              setImportOpen(false);
              setUploadOpen(true);
            }}
          />
        </Card>

        <BatchList
          refreshToken={refreshToken}
          onOpenReport={(record) => { setReportRecord(record); setReportOpen(true); }}
        />
      </div>
      <Modal
        title="模板说明及下载"
        open={explainOpen}
        onOk={() => setExplainOpen(false)}
        onCancel={() => setExplainOpen(false)}
        okText="知道了"
        cancelText="关闭"
      >
        <List
          dataSource={templates}
          renderItem={(item) => (
            <List.Item
              actions={[
                <Button
                  key="download"
                  icon={<DownloadOutlined />}
                  onClick={() => downloadTemplate(item.type)}
                >
                  下载
                </Button>,
              ]}
            >
              <List.Item.Meta
                title={item.name}
                description={item.description}
              />
            </List.Item>
          )}
        />
      </Modal>
      <ReportDialog open={reportOpen} onClose={() => setReportOpen(false)} record={reportRecord} />
      <UploadDialog open={uploadOpen} onClose={() => setUploadOpen(false)} onConfirm={confirmUploadWorkspace} />
      <ImportDialog
        open={importOpen}
        onClose={() => setImportOpen(false)}
        workspace={workspace}
        onBatchAdd={() => {
          setRefreshToken(Date.now());
        }}
      />
      <PrecheckDialog open={precheckOpen} onClose={() => setPrecheckOpen(false)} workspace={workspace} />
    </div>
  );
};

export default BatchPublishPage;
